import React from "react";

const SettingHeader = ({
  title,
  LeftComponent = () => {},
  RightComponent = () => {},
}) => {
  return (
    <>
      <div className="row align-items-center my-3 mt-md-4">
        <div className="col-12 col-sm-6 col-md-5 col-lg-4 col-xl-6 d-flex pe-0">
          <h5 className="intro-title profile-heading p-0 d-flex align-items-center">{title}</h5>
          <div>
            <LeftComponent key="settings-header-left" />
          </div>
        </div>
        <RightComponent key="settings-header-right" />
      </div>
    </>
  );
};

export default SettingHeader;
